import React from 'react';
import { DatePicker } from 'antd';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

export const DateRangePicker = ({
  label,
  error,
  helperText,
  layout,
  labelCol,
  wrapperCol,
  required,
  value,
  onChange,
  format = 'YYYY-MM-DD',
  showTime = false,
  ...props
}) => {
  const handleChange = (dates) => {
    onChange?.(dates);
  };

  return (
    <InputWrapper
      label={label}
      error={error}
      helperText={helperText}
      required={required}
      layout={layout}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <RangePicker
        value={value ? value.map(date => date ? dayjs(date) : null) : null}
        onChange={handleChange}
        format={format}
        status={error ? 'error' : ''}
        showTime={showTime}
        style={{ width: '100%' }}
        {...props}
      />
    </InputWrapper>
  );
};

DateRangePicker.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  required: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.any),
  onChange: PropTypes.func,
  format: PropTypes.string,
  showTime: PropTypes.bool,
};

export default DateRangePicker; 